import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const ONE_AND_MORE_ACTIVITY_FRAGMENT = gql `
  fragment OneAndMoreActivityFragment on OneAndMoreActivity {
    rounds {
      steps {
        answer
        answerAudio {
          id
          audio {
            ...AssetFragment
          }
        }
        answerImage {
          id
          image {
            ...AssetFragment
          }
        }
        id
        monochromeImage {
          id
          image {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default ONE_AND_MORE_ACTIVITY_FRAGMENT;
